import React from 'react';

import { URLQueryParamNames } from '@src/types/urlQueryParamNames';

import Checkbox from '@helsenorge/designsystem-react/components/Checkbox';

interface VerktoytypeDropdownProps {
  filters: Record<string, boolean>;
  verktoytype: { displayname: string; value: string };
  verktoytyperValgt: string[];
  setVerktoyTyperValgt: (arr: string[]) => void;
  setDelayedFilter: (key: string, val: string) => void;
}

// Use forwardRef to support refs from parent components (e.g., Dropdown)
const VerktoytypeDropdown = React.forwardRef<HTMLInputElement, VerktoytypeDropdownProps>(
  ({ filters, verktoytype, verktoytyperValgt, setVerktoyTyperValgt, setDelayedFilter }, ref) => {
    const keyBase = `${URLQueryParamNames.VerktoyType.toLowerCase()}-${verktoytype.displayname}`;
    return (
      <Checkbox
        key={keyBase}
        ref={ref}
        inputId={`${keyBase}-${verktoytype.value}`}
        label={verktoytype.displayname}
        value={verktoytype.displayname}
        checked={filters && !!filters[keyBase]}
        onChange={e => {
          setVerktoyTyperValgt(
            e.target.checked
              ? [...verktoytyperValgt, verktoytype.value].filter((v, i, a) => a.indexOf(v) === i)
              : verktoytyperValgt.filter(v => v !== verktoytype.value)
          );
          setDelayedFilter(keyBase, e.target.checked ? e.target.value : '');
        }}
      />
    );
  }
);

VerktoytypeDropdown.displayName = 'VerktoytypeDropdown';

export default VerktoytypeDropdown;
